import { Component } from '@angular/core';
import { wizardPages, WizardPage, FormField } from './wizard-form-builder';

@Component({
  selector: 'app-wizard-form',
  templateUrl: './wizard-form.component.html',
  styleUrls: ['./wizard-form.component.scss']
})
export class WizardFormComponent {
  pages: WizardPage[] = wizardPages;
  currentPageIndex = 0;
  formData: any = {};

  get currentPage(): WizardPage {
    return this.pages[this.currentPageIndex];
  }

  shouldShow(field: FormField): boolean {
    if (field.type === 'group' && !this.formData[field.name]) {
      this.formData[field.name] = {};
    }
    return !field.visibilityCondition || field.visibilityCondition(this.formData);
  }

  // Navigate to next page based on logic
  nextPage(): void {
    let nextId = this.currentPage.nextPage?.(this.formData);
    while (nextId) {
      const nextPage = this.pages.find(p => p.id === nextId);
      if (!nextPage) break;

      const visible = !nextPage.visibilityCondition || nextPage.visibilityCondition(this.formData);
      if (visible) {
        this.currentPageIndex = this.pages.findIndex(p => p.id === nextId);
        return;
      }

      // Call the nextPage function of the skipped page to continue the chain
      nextId = nextPage.nextPage?.(this.formData);
    }
  }

  previousPage(): void {
    for (let i = this.currentPageIndex - 1; i >= 0; i--) {
      const page = this.pages[i];
      if (!page.visibilityCondition || page.visibilityCondition(this.formData)) {
        this.currentPageIndex = i;
        return;
      }
    }
  }

  // Handle checkbox arrays
  onCheckboxChange(fieldName: string, value: string, event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    if (!Array.isArray(this.formData[fieldName])) {
      this.formData[fieldName] = [];
    }

    if (checkbox.checked) {
      this.formData[fieldName].push(value);
    } else {
      const index = this.formData[fieldName].indexOf(value);
      if (index >= 0) {
        this.formData[fieldName].splice(index, 1);
      }
    }
  }

  // Repeat group handling
  addRepeatGroup(name: string): void {
    if (!this.formData[name]) {
      this.formData[name] = [];
    }
    this.formData[name].push({});
  }

  removeRepeatGroup(name: string, index: number): void {
    if (this.formData[name]) {
      this.formData[name].splice(index, 1);
    }
  }

  isCurrentPageValid(): boolean {
    for (const field of this.currentPage.fields) {
      if (!this.shouldShow(field)) continue;

      const value = this.formData[field.name];

      if (field.type === 'group') {
        if (!value) return false;
        for (const subField of field.fields) {
          if (subField.required && (!value[subField.name] || value[subField.name] === '')) {
            return false;
          }
        }
      }

      else if (field.type === 'repeatGroup') {
        if (!Array.isArray(value) || value.length === 0) return false;

        for (const groupItem of value) {
          for (const subField of field.fields) {
            if (subField.required && (!groupItem[subField.name] || groupItem[subField.name] === '')) {
              return false;
            }
          }
        }
      }

      else if (field.required) {
        if (field.type === 'checkbox') {
          if (!Array.isArray(value) || value.length === 0) return false;
        } else if (value === null || value === undefined || value === '') {
          return false;
        }
      }
    }

    return true;
  }


}
